const OVERRIDES = {
  projections: "Projections",
  vente_occasion: "Vente d'occasion",
  date: "Date",
  duree: "Durée",
  kilometrage: "Kilométrage",
  taux_vr: "Taux VR",
  montant_vr: "Montant VR",
  valeur_theorique: "Valeur théorique",
  indemnites: "Indemnités",
  montant_kilometres_supplementaires: "Montant km supplémentaires",
  prix_de_vente_interne_ttc: "Prix de vente interne TTC",
  marge_buy_back: "Marge buy-back",
  marge_brute: "Marge brute",
  marge_frais: "Marge frais",
  marge_nette: "Marge nette",
  marge_totale: "Marge totale",
  commission: "Commission",
};

export const humanize = (key) => {
  if (!key) return "";
  if (OVERRIDES[key]) return OVERRIDES[key];
  const spaced = key.replace(/_/g, " ");
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
};
